var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex registers justify-content-center general"},[_c('Registers',{staticClass:"isDesktop"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }